module.exports = __webpack_public_path__ + "img/poster-bassline.bf600a8e.png";